module.exports = __webpack_public_path__ + "static/bg-wedding-mw-adae733152dc5dbbc905de33c68c0392.jpg";